import $ from 'jquery';

export let cr_state = 0;
export let open_menu_state = 0;

/**
 * Open the select option dropdown
 */
export const openSelectOptions = {
    openSelectOption: function (j_state, selector) {
        if (cr_state == 0) {
            $('.'+selector).fadeIn();
            $('#'+selector).removeClass('animate__fadeOutTop');
            $('#'+selector).addClass('animate__fadeInTop');
        } else {
            $('#'+selector).removeClass('animate__fadeInTop');
            $('#'+selector).addClass('animate__fadeOutTop');
            $('.'+selector).fadeOut();
        }

        if(j_state == 0) {
            j_state = 1;
        } else {
            j_state = 0;
        }

        cr_state = j_state;
        return cr_state;
    }
}

/**
 * Choose an option in select option
 */
export const selectOption = {
    chooseOption: function (selected_id, selector) {

        $('#'+selector).removeClass('animate__fadeInTop');
        $('#'+selector).addClass('animate__fadeOutTop');
        $('.'+selector).fadeOut();

        cr_state = 0;

        return cr_state;
    }
}